var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    class: {
      'content-img': true,
      'irregularImg': _vm.isCar
    },
    style: {
      backgroundImage: `url(${_vm.item.pic_url})`
    }
  }), _c('div', {
    staticClass: "content-info"
  }, [_vm.item.product_name ? _c('div', {
    staticClass: "poi-name",
    style: _vm.poiFontWeight
  }, [_vm._v(" " + _vm._s(_vm.item.product_name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "poi-info-price"
  }, [_vm.item.sale_price_str && !_vm.isCar && !_vm.isHouse ? _c('div', {
    staticClass: "price-prefix"
  }, [_vm._v("¥")]) : _vm._e(), _vm.item.sale_price_str ? _c('div', {
    staticClass: "price-num"
  }, [_vm._v(" " + _vm._s(_vm.item.sale_price_str) + " ")]) : _vm._e(), _vm.item.origin_price_str ? _c('div', {
    staticClass: "discount",
    style: _vm.isHouse ? 'text-decoration: none;' : ''
  }, [_vm._v(" ¥" + _vm._s(_vm.item.origin_price_str) + " ")]) : _vm._e(), _vm.item.discount_rate_str ? _c('div', {
    staticClass: "sku-label"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v(_vm._s(_vm.item.discount_rate_str))]), _vm._v("折 ")]) : _vm._e(), _vm.item.label_text ? _c('div', {
    staticClass: "advertisement"
  }, [_vm._v(" " + _vm._s(_vm.item.label_text) + " ")]) : _vm._e()])])]), _vm.item.btn_text ? _c('div', {
    staticClass: "moreText",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase(_vm.item.billing_url);
      }
    }
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v(" " + _vm._s(_vm.item.btn_text) + " ")]), _c('div', {
    staticClass: "icon"
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };